// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ps-z","tooltipWrapper":"qs-z","icon":"rs-z","tooltip":"ss-z","content":"ts-z"};